define("shared/types/post-tagging", ["exports"], function (_exports) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.TagTypeMap = _exports.TagType = _exports.ReverseTagTypeMap = void 0;
  0; //eaimeta@70e063a35619d71feaimeta@70e063a35619d71f
  let TagType = _exports.TagType = /*#__PURE__*/function (TagType) {
    TagType["Product"] = "product";
    TagType["Campaign"] = "campaign";
    return TagType;
  }({});
  const TagTypeMap = _exports.TagTypeMap = {
    [TagType.Product]: 'post',
    [TagType.Campaign]: 'campaign'
  };
  const ReverseTagTypeMap = _exports.ReverseTagTypeMap = {
    [TagTypeMap[TagType.Product]]: TagType.Product,
    [TagTypeMap[TagType.Campaign]]: TagType.Campaign
  };
});